import { render, staticRenderFns } from "./amendmentItem.vue?vue&type=template&id=dcd868b4&scoped=true&"
import script from "./amendmentItem.vue?vue&type=script&lang=js&"
export * from "./amendmentItem.vue?vue&type=script&lang=js&"
import style0 from "./amendmentItem.vue?vue&type=style&index=0&id=dcd868b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd868b4",
  null
  
)

export default component.exports